import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AcDialog, DIALOG_CONFIG} from 'ac-infra';
import {FormControl, FormGroup, NgForm} from '@angular/forms';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {RoleTypeEnum} from '../../../../services/enums/role-type.enum';
import {confirmPasswordValidator} from '../../../../utils/confirm-password-validator.directive';
import {CustomErrorStateMatcher} from '../../../../utils/custom-error-state-matcher.directive';

@AcDialog({
  width: 500
})
@Component({
  selector: 'change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss']
})
export class ChangePasswordDialogComponent implements OnInit, AfterViewInit{

  @ViewChild('changePasswordForm') changePasswordForm: NgForm;
  canSubmit: boolean;
  data: any = {};
  userName: string;
  confirmationControl: FormGroup;
  matcher: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig,
              private userPrivilege: UserPrivilegeService) {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.NORMALIZATION_GROUP);
    dialogConfig.submitButtonDisabled = true;
    this.data = this.dialogConfig.dialogData.data;
    this.userName = dialogConfig.dialogData.userName;
  }

  ngOnInit(): void {
    this.matcher = new CustomErrorStateMatcher();

    this.confirmationControl = new FormGroup({
      'old-password': new FormControl(),
      password: new FormControl(),
      userName: new FormControl(),
      'confirm-password': new FormControl(),
    }, { validators: confirmPasswordValidator });
  }

  ngAfterViewInit(): void {
    this.changePasswordForm.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.changePasswordForm.form.valid;
    });
  }
}
